import React, { InputHTMLAttributes, ReactNode } from 'react';
import cn from 'classnames';
import styles from './FormInputs.module.scss';

export default function Toggle({
  name,
  checked,
  onChange,
  className,
  disabled,
  children,
  clickableLabel = null,
}: InputHTMLAttributes<HTMLInputElement> & { clickableLabel?: ReactNode }) {
  return (
    <div className={cn(styles.toggle, className, disabled && styles.toggleDisabled)}>
      {children && <span className={styles.label}>{children}</span>}
      <span className={styles.input}>
        <label className="form-toggle">
          {clickableLabel}
          <input
            name={name}
            className="form-toggle-input"
            type="checkbox"
            checked={checked}
            onChange={onChange}
            disabled={disabled}
          />
          <span className="form-toggle-switch" />
        </label>
      </span>
    </div>
  );
}
